<template>
  <div id="osList">
    <!-- <div class="row col-12 d-flex align-items-center justify-content-between">
      <h5>
        <i class="fas fa-tools"></i>
        Ordens de serviço em aberto
      </h5>
      <div class="col"> -->

        <filtros-externa v-if="fornecExt" @update-filters="updateFilters">
          <template slot="pagination"><os-pagination></os-pagination></template>
        </filtros-externa>
      <!-- </div>
    </div> -->


    <div class="col-12 text-center pt-3 animated fadeout" v-if="items == 'loading'">
      <span style="font-size: 2rem">
        <i class="fas fa-pulse fa-spinner mr-3"></i>{{this.$t('Carregando')}}...
      </span>
    </div>
    <div class="row" v-if="items && items !== 'loading'">
      <div class="col-12 mb-3 text-center">
        <span v-if="items == 'loading'">
          {{this.$t('Carregando')}}...
        </span>
        <span v-if="items !== 'loading' && items.total > 0">
          {{ $t('Exibindo resultado') }}
          <span class="badge badge-light" style="font-size:18px">{{ items.from }} <span
              class="font-weight-normal">a</span>
            {{ items.to }}</span>
            {{ $t('de') }}
          <span class="badge badge-warning" style="font-size:18px">{{
            items.total
          }}</span>
        </span>
        <span class="w-100 text-center" v-if="items !== 'loading' && !items.total">
          {{ $t('Nenhum resultado encontrado') }}.
        </span>
      </div>

      <os-card class="col-xl-3 col-lg-4 col-md-6" v-for="(os, index) in items.data" :key="index" :os="os"></os-card>

      <div class="col-12 d-flex justify-content-center mt-2 mb-5">
        <os-pagination position="bottom"></os-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OsCard from '@/components/OsCard'
import FiltrosExterna from '@/components/FiltrosExterna'
import OsPagination from '@/components/OsPagination'

export default {
  components: {
    OsCard,
    FiltrosExterna,
    OsPagination
  },

  created() {
    const filial = this.$store.getters['filial/filial']
    const filters = {
      placa: '',
      tipo: '',
      de: '',
      ate: '',
      codigo: ''
    }
    if (this.validateFornecedorExterno) {
      filters.fornecedor = filial.tecnicoId
    }

    this.$store.commit('os/setFilters', { filters: filters })
    this.$emit('update-filters', { filters: filters })
  },

  data() {
    return {
      showFiltros: false,
      recarregarFiltro: true,
    }
  },

  computed: {
    validateFornecedorExterno() {
      const fornecExterno = this.$store.getters['colaborador/findMecanico']

      if (fornecExterno == null) {
        return false
      }

      return true
    },

    fornecExt() {
      const filial = this.$store.getters['filial/filial']

      if (filial.fornecExt === null) {
        return true
      }

      return false
    },

    items() {
      if (!this.$store.getters['os/page'](this.paginacao.currentPage)) {
        this.fetchItemsFromApi()
      }

      return this.$store.getters['os/page'](this.paginacao.currentPage)

    },
    paginacao() {
      return this.$store.getters['os/pagination']
    }
  },

  mounted() {
    this.$store.dispatch('os/fetchFromApiExterna', {})
  },

  methods: {
    applyFilters() {
      let filters = { ...this.internalFilters }
      // console.log(filters)

      this.$store.commit('os/setFilters', { filters: filters })
      this.$emit('update-filters', { filters: filters })

      this.updateFilters()
    },
    refreshFilter() {
      this.recarregarFiltro = false
    },

    updateFilters(newFilters) {
      this.$store.dispatch('os/reset')
      this.fetchItemsFromApi()
      this.refreshFilter = 1
    },

    fetchItemsFromApi() {
      this.$store.dispatch('os/fetchFromApiExterna')
    }
  }
}
</script>

<style lang="scss">
.icon--custom {
  top: 50px;
}
</style>